import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./lib/analytics"; // Import analytics configuration
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://ec72deb33da817fd3a7087118d761646@o4509193917628416.ingest.us.sentry.io/4509193988210688",
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
